module.exports = __webpack_public_path__ + "static/media/Picture.3cb4c491.svg";